/** At least one character from this set (message shown to users). */
export const PASSWORD_SPECIAL_CHARS = '@$!%*?&^#()';

const HAS_LOWERCASE = /[a-z]/;
const HAS_UPPERCASE = /[A-Z]/;
const HAS_DIGIT = /\d/;
const HAS_REQUIRED_SPECIAL = new RegExp(`[${PASSWORD_SPECIAL_CHARS.replace(/[\\^[\]-]/g, '\\$&')}]`);

export const PASSWORD_REQUIREMENTS_MESSAGE =
    'Password must be at least 8 characters and include uppercase, lowercase, a number, and a special character (@, $, !, %, *, ?, &, ^, #, (, )).';

export function isValidPassword(password: string): boolean {
    if (password.length < 8) return false;
    if (!HAS_LOWERCASE.test(password)) return false;
    if (!HAS_UPPERCASE.test(password)) return false;
    if (!HAS_DIGIT.test(password)) return false;
    if (!HAS_REQUIRED_SPECIAL.test(password)) return false;
    return true;
}
